<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001096')"
						paramKey="opCd"
						@commInput="setSearchParam"
						:propData="searchParams.opCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001163')"
						paramKey="useYn"
						:options="useYnList"
						:propData="searchParams.useYn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/OpCdMng/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({});
		}
	},
	methods: {
		...serviceMethods,
		async changeSelect(val, key) {
			await this.setSearchParam_({ key: key, value: val });
		},
		async setSearchParam(param) {
			await this.setSearchParam_(param);
		},
		searchList() {
			this.$sf_toggleLoading(true);
			this.getOpCdMng_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	async created() {
		try {
			await this.searchList();
			await this.getCommCodes_({ key: 'msgIdList', codeType: 'MSG_KEY_TYPE' });
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
